import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";
import { AddressModel } from "./address.model";

export interface Branch {
  id: string;
  clientId: string;
  name: string;
  logo: string;
  favicon: string;
  background: string;
  color: string;
  referer: string;
  baseline: string;
  active: boolean;
  connected: boolean;
  address?:AddressModel;
  personConnectionId: string;
  organisationConnectionId: string;
  supportEmail: string;
  isPublic: boolean;
  vanityUrl: string;
  flowsparks: boolean;
  ssoLoginScreen: boolean;
  catalogUrl: string;
  academy:boolean;
  termsAndConditions: string;
}


@Injectable({
  providedIn: 'root'
})

export class BranchAdapter implements Adapter<Branch> {
  constructor() {
  }

  adapt(item: any): Branch {
    return {
      id: item.id,
      clientId: item.client?item.client.split('/').pop():'',
      active: item.active??false,
      background:item.background??'',
      baseline:item.baseline??'',
      catalogUrl:item.catalogUrl??'',
      color: item.colour?item.colour:'#0B145A',
      connected: item.connect ?? false,
      flowsparks: item.flowsparks??false,
      isPublic: item.public??false,
      address:item.address??null,
      logo: item.logo??'',
      favicon: item.favicon??'',
      name: item.name??'',
      organisationConnectionId:'',
      personConnectionId:'',
      referer:item.referer??'',
      ssoLoginScreen: item.ssoLoginScreen??false,
      supportEmail:item.emailAddress??'',
      termsAndConditions: item.termsAndConditions??'',
      vanityUrl: item.vanityUrl??'',
      academy:item.enableAcademy??false
    }as Branch
  }
}
